import { render, staticRenderFns } from "./CreateGroupStageStandingsTournament.vue?vue&type=template&id=34577872"
import script from "./CreateGroupStageStandingsTournament.vue?vue&type=script&lang=js"
export * from "./CreateGroupStageStandingsTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports